import { useSelector } from "react-redux";

export default function useGetUserGroupListForSelectedUser() {
  const userGroupListForSelectedUser = useSelector(
    (rootState) => rootState.userGroupsListForUserView.userGroupsListForUserView.value
  );

  const userGroupScopeList = useSelector(
    (rootState) => rootState.userGroup.userGroupScopeList.value
  );

  return {
    ...userGroupListForSelectedUser,
    userGroupScopeList: userGroupScopeList
  };
}

export function useCheckUserGroupListForSelectedUserIsLoaded() {
  const userGroupListForSelectedUser = useSelector(
    (rootState) => { return rootState.userGroupsListForUserView.userGroupsListForUserView}
  ); 
  return !!userGroupListForSelectedUser?.progress
}
